export const entityBoxes = {
  namespaced: true,
  //persistent: ["department", "process", "datasource", "data"],

  state: {
    department: undefined,
    process: undefined,
    datasource: undefined,
    dataCategory: undefined,
    data: undefined,
    datasubject: undefined,
  },
  getters: {
    department: (state) => state.department,
    process: (state) => state.process,
    datasource: (state) => state.datasource,
    dataCategory: (state) => state.dataCategory,
    data: (state) => state.data,
    datasubject: (state) => state.datasubject,
  },
  mutations: {
    clear: (state, va) => {
      state.department = undefined;
      state.process = undefined;
      state.datasource = undefined;
      state.dataCategory = undefined;
      state.data = undefined;
      state.datasubject = undefined;
    },

    clearFrom: (state, value) => {
      let toBeCleared = [];
      if (value == "process") {
        toBeCleared = ["process", "datasource", "dataCategory", "data", "datasubject"];
      } else if (value == "datasource") {
        toBeCleared = ["datasource", "dataCategory", "data", "datasubject"];
      } else if (value == "dataCategory") {
        toBeCleared = ["dataCategory", "data", "datasubject"];
      } else if (value == "data") {
        toBeCleared = ["data", "datasubject"];
      } else if (value == "datasubject") {
        toBeCleared = ["datasubject"];
      }

      toBeCleared.forEach((i) => {
        if (state[i]) {
          state[i] = undefined;
        }
      });
    },
    department: (state, value) => {
      if (state.department == value) {
        return;
      }
      state.department = value;
      state.process = undefined;
      state.datasource = undefined;
      state.dataCategory = undefined;
      state.data = undefined;
      state.datasubject = undefined;
    },
    process: (state, value) => {
      if (state.process == value) {
        return;
      }
      state.process = value;
      state.datasource = undefined;
      state.dataCategory = undefined;
      state.data = undefined;
      state.datasubject = undefined;
    },
    datasource: (state, value) => {
      if (state.datasource == value) {
        return;
      }
      state.datasource = value;
      state.dataCategory = undefined;
      state.data = undefined;
      state.datasubject = undefined;
    },
    dataCategory: (state, value) => {
      if (state.dataCategory == value) {
        return;
      }
      state.dataCategory = value;
      state.data = undefined;
      state.datasubject = undefined;
    },
    data: (state, value) => {
      if (state.data == value) {
        return;
      }
      state.data = value;
      state.datasubject = undefined;
    },
    datasubject: (state, value) => {
      if (state.datasubject == value) {
        return;
      }
      state.datasubject = value;
    },
  },
  actions: {
    async selectDepartment({ getters, rootGetters, commit, dispatch }, item) {
      if (getters.department?._id == item._id) {
        commit("department", undefined);
        commit("organizationDepartment/selectedEntity", undefined, { root: true });
      } else {
        commit("department", item);
        commit("organizationDepartment/selectedEntity", item, { root: true });
      }
    },
    async selectProcess({ getters, rootGetters, commit, dispatch }, item) {
      if (getters.process?._id == item._id) {
        commit("process", undefined);
        commit("organizationDepartmentProcess/selectedEntity", undefined, { root: true });
      } else {
        commit("process", item);
        commit("organizationDepartmentProcess/selectedEntity", item, { root: true });
      }
    },
    async selectDatasource({ getters, rootGetters, commit, dispatch }, item) {
      if (getters.datasource?._id == item._id) {
        commit("datasource", undefined);
        commit("organizationProcessDatasource/selectedEntity", undefined, { root: true });
      } else {
        commit("datasource", item);
        commit("organizationProcessDatasource/selectedEntity", item, { root: true });
      }
    },

    async selectDataCategory({ getters, rootGetters, commit, dispatch }, item) {
      if (getters.dataCategory?._id == item._id) {
        commit("dataCategory", undefined);
        commit("organizationProcessDatasource/selectedDataCategory", undefined, { root: true });
      } else {
        commit("dataCategory", item);
        commit("organizationProcessDatasource/selectedDataCategory", item, { root: true });
      }
    },

    async selectData({ getters, rootGetters, commit, dispatch }, item) {
      if (getters.data?._id == item._id) {
        commit("data", undefined);
        commit("organizationDatasourceData/selectedEntity", undefined, { root: true });
      } else {
        commit("data", item);
        commit("organizationDatasourceData/selectedEntity", item, { root: true });
      }
    },
    async selectDatasubject({ getters, rootGetters, commit, dispatch }, item) {
      if (getters.datasubject?._id == item._id) {
        commit("datasubject", undefined);
        commit("organizationDatasubject/selectedEntity", undefined, { root: true });
      } else {
        commit("datasubject", item);
        commit("organizationDatasubject/selectedEntity", item, { root: true });
      }
    },
  },
};
